import { Page, View, Text, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});
Font.registerHyphenationCallback(word => [word]);
const styles = StyleSheet.create({
  page: {
    paddingRight: 8,
    paddingLeft: 5,
    fontFamily: "Roboto",
    fontSize: 11,
    position: "relative",
    backgroundColor: "#fff",
    flexDirection: "column",
    paddingTop: 110,
    paddingBottom: 110,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -10,
    right: 0,
    width: 280,
    marginBottom: 80,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
    marginTop: "20px",
  },
  mainContent: {
    flex: 1,
    justifyContent :"center",
    alignContent:"center",
    marginTop: 0,
    marginBottom: 0,
    paddingHorizontal: 40,
  },
  maintext: {
    fontSize: 21,
    textAlign: "center",
    lineHeight: 1.2,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});
const MotivationPage = ({ assets, showPageNumber }) => (
  <Page size="A4" style={styles.page}>
    {/* Design elements that should appear on every page */}
    <Image src={assets.upper} style={styles.upperDesign} fixed />
    <Image src={assets.lower} style={styles.lowerDesign} fixed />
    <Image src={assets.logo2} style={styles.logo2} fixed />

    <View style={styles.mainContent}>
      <View style={styles.container}>
        <Text style={styles.maintext}>
          Just as a compass points to the True North, we aim to provide clarity and direction for your professional voyage. Let's embark on this colorful and vibrant expedition together, where your values, interests, and personality traits serve as the guiding stars to chart your course. 
        </Text>
      </View>
    </View>
    {/* Footer - page number only */}
    <>
           {showPageNumber && (
             <View style={styles.pageNumber_Box}>
               <Text
                 style={styles.pageNumber}
                 render={({ pageNumber, totalPages }) => `${pageNumber}`}
                 fixed
               />
             </View>
           )}
         </>
  </Page>
);

export default MotivationPage;
